// Notification status variants for badges
export const notificationStatusVariants = {
  queued: "warning",
  sending: "info",
  sent: "success",
  failed: "danger",
  cancelled: "neutral",
};

// Notification status messages
export const notificationStatusMessages = {
  queued: "Queued",
  sending: "Sending",
  sent: "Sent",
  failed: "Failed",
  cancelled: "Cancelled",
};

// Template status variants
export const templateStatusVariants = {
  active: "success",
  draft: "warning",
  archived: "neutral",
};

// Button configurations for different statuses
export const jobButtonsConfig = {
  queued: [
    { variant: "danger", action: "cancel", label: "Cancel" },
    { variant: "primary", action: "view", label: "View Details" },
  ],
  sending: [{ variant: "primary", action: "view", label: "View Details" }],
  sent: [{ variant: "primary", action: "view", label: "View Details" }],
  failed: [
    { variant: "warning", action: "retry", label: "Retry" },
    { variant: "primary", action: "view", label: "View Details" },
  ],
  cancelled: [{ variant: "primary", action: "view", label: "View Details" }],
};

// Placeholder options
export const placeholderOptions = [
  { value: "{{userName}}", label: "User Name" },
  { value: "{{userEmail}}", label: "User Email" },
  { value: "{{productName}}", label: "Product Name" },
  { value: "{{orderNumber}}", label: "Order Number" },
  { value: "{{date}}", label: "Current Date" },
  { value: "{{time}}", label: "Current Time" },
];

// Platform options
export const platformOptions = [
  { value: "all", label: "All Platforms" },
  { value: "APNS", label: "iOS" },
  { value: "FCM", label: "Android" },
  { value: "WEB", label: "Web" },
  { value: "WHATSAPP", label: "WhatsApp" },
];

// Channel display configuration
export const channelDisplayConfig = {
  showDisabled: false, // If true, show disabled channels with disabled state, if false, hide them completely
  autoSelectSingleChannel: true, // If true, auto-select the single available channel and hide "All Platforms"
};

// Chart color palette
export const chartColors = {
  primary: "#6366f1",
  success: "#10b981",
  warning: "#f59e0b",
  danger: "#ef4444",
  info: "#3b82f6",
  secondary: "#8b5cf6",
};

// Job status enum matching backend
export const jobStatusEnum = {
  QUEUED: "QUEUED",
  SENDING: "SENDING",
  SENT: "SENT",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
};

// Add these if not already present
